module.exports = __webpack_public_path__ + "img/techniques1.9f63e8dc.png";